export default "__VITE_ASSET__0185335a__"